export default __webpack_public_path__ + "static/media/partner_logo_mimiro.2c8ae9f0.svg";